import MoreMenu from './MoreMenu';

export default MoreMenu;
